import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeCardUploadAdd } from './Pages';

export const EmployeeCardUploadRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeCardUploadAdd} />
    </Fragment>
)